module.exports = __webpack_public_path__ + "img/fashion_design.fa117aea.jpg";